import { MultiSelect, MultiSelectProps } from '@mantine/core';
import { deduplicateItems } from '../../helpers/general-helpers';
import {
  createSafeMultiSelectChangeHandler,
  validateMultiSelectData,
  validateMultiSelectValue,
} from '../../helpers/mantine-select-helpers';
import { useGlobalStore } from '../../store/global-store/global-store';
import { commonMultiSelectProps } from './multiselect.helpers';

export function TeamMultiselect(props: Omit<MultiSelectProps, 'data'>) {
  const { value: teamIds, onChange: handleTeamSelected, ...rest } = props;
  const teams = useGlobalStore((state) => deduplicateItems(state.teams || []));

  // Prepare safe data for the MultiSelect
  const safeTeamsData =
    teams && Array.isArray(teams)
      ? teams.filter((t) => t && t.id && t.name).map((t) => ({ value: t.id, label: t.name }))
      : [];

  // Create a safe onChange handler
  const safeChangeHandler = createSafeMultiSelectChangeHandler(handleTeamSelected);

  return (
    <MultiSelect
      {...rest}
      {...commonMultiSelectProps}
      value={validateMultiSelectValue(safeTeamsData.length > 0 ? teamIds : [])}
      data={validateMultiSelectData(safeTeamsData)}
      onChange={safeChangeHandler}
      maxDropdownHeight={400}
      searchable
      clearable
      limit={50}
    />
  );
}
